import * as React from 'react';
import { useContext, useEffect } from 'react';
import { ActionMenuView } from './ActionMenu.view';
import { useSelectedOrganization } from '../../../hooks/useSelectedOrganization';
import { useGetUnreadNotificationsLazyQuery } from '../../../models/graphql';
import { triggerErrorToast } from '../../../helpers/triggerErrorToast';
import { RightDrawerTypeEnum } from '../../../constants/right-drawer';
import { AppContext } from '../../../providers/AppProvider';

export const ActionMenuController = (): JSX.Element => {
  const [getUnreadNotifications, { data, startPolling, stopPolling }] = useGetUnreadNotificationsLazyQuery();
  const { rightDrawerState, toggleRightDrawer } = useContext(AppContext);
  const { selectedOrganization } = useSelectedOrganization();

  // We use polling to fetch new notifications every 5s only if the notifications drawer is clossed. If it is open, we don't poll
  useEffect(() => {
    if (selectedOrganization) {
      getUnreadNotifications({
        variables: { orgId: selectedOrganization.id }
      }).catch(e => triggerErrorToast('Error Fetching Notifications')(e));
    }
  }, [getUnreadNotifications, selectedOrganization]);

  useEffect(() => {
    if (rightDrawerState.type === RightDrawerTypeEnum.notifications) {
      stopPolling();
    } else {
      startPolling(5000);
    }
  }, [rightDrawerState.type, startPolling, stopPolling]);

  return (
    <ActionMenuView
      toggleRightDrawer={toggleRightDrawer}
      unreadNotifications={data?.unreadNotificationCount}
      rightDrawerState={rightDrawerState}
    />
  );
};
